/** sessionStorage that may be blocked: reads come back empty, writes are dropped. */
export const tabStore = {
    get(key: string): string | null {
        try { return sessionStorage.getItem(key); } catch { return null; }
    },
    set(key: string, value: string): void {
        try { sessionStorage.setItem(key, value); } catch { /* not kept */ }
    },
    remove(key: string): void {
        try { sessionStorage.removeItem(key); } catch { /* nothing kept */ }
    },
};
